// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SelfServiceController = function ($scope, $http, SelfService) {
    $scope.plans = SelfService.get();
    $scope.save = function () {
        $http({
            method: "POST",
            url: "/api/v1/SelfService",
            params: null,
            data: {},
            headers: {},
            cache: false
        }).then(function (response) {
            $scope.data = response.data;
        });
    };
};
SelfServiceController.$inject = ['$scope', '$http', 'SelfService'];
